import { render, staticRenderFns } from "./EcoLogo.vue?vue&type=template&id=59733748&scoped=true&"
import script from "./EcoLogo.vue?vue&type=script&lang=js&"
export * from "./EcoLogo.vue?vue&type=script&lang=js&"
import style0 from "./EcoLogo.vue?vue&type=style&index=0&id=59733748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59733748",
  null
  
)

export default component.exports